module.exports = __webpack_public_path__ + "media/recipes/82-d00bd9ac.png";